import { combineReducers } from 'redux';

import preferences from './slices/preferences';
import website from './slices/website';
import listings from './slices/listings';
import dictionaries from './slices/dictionaries';
import amenities from './slices/amenities';
import calendarEvents from './slices/calendar-events';

const appReducer = combineReducers({
  preferences,
  website,
  listings,
  dictionaries,
  amenities,
  calendarEvents,
});

const rootReducer = appReducer;

export default rootReducer;
